module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j-album-upload"
  }, [_c('div', {
    staticClass: "view-box"
  }, [_vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: file.id,
      staticClass: "view-item"
    }, [_c('div', {
      staticClass: "view-item-container",
      on: {
        "click": function($event) {
          return _vm.previewImage(file)
        }
      }
    }, [(file.thumb) ? _c('img', {
      staticClass: "image-thumb",
      class: {
        'image-thumb-v': file.width > file.height
      },
      attrs: {
        "src": file.thumb
      }
    }) : _vm._e(), _vm._v(" "), (!file.success) ? _c('div', {
      staticClass: "j-album-process",
      style: ({
        height: (100 - file.progress) * .82 + 'px'
      })
    }, [_vm._v("\n        " + _vm._s(file.progress) + "%\n      ")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "remove-btn",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$refs.upload.remove(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length < 9),
      expression: "files.length < 9"
    }],
    staticClass: "view-item select-button-container"
  }, [_c('div', {
    staticClass: "view-item-container"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "select-button text-muted",
    attrs: {
      "post-action": _vm.postAction,
      "extensions": _vm.extensions,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "drop": _vm.drop,
      "drop-directory": _vm.dropDirectory,
      "size": _vm.size,
      "thread": _vm.thread,
      "headers": _vm.headers,
      "data": _vm.data,
      "max-length": _vm.maxLength,
      "preload": _vm.preload
    },
    on: {
      "input-filter": _vm.inputFilter,
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_c('div', {
    staticClass: "select-button-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/camera_default@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("选择图片")])])])], 1)])], 2), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eed1ea20"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/album.vue
// module id = 295
// module chunks = 107